import { useState } from 'react';
import { LottieAnimation } from '@/components/LottieAnimation';

interface ConfettiBurstProps {
  className?: string;
}

const loadConfetti = () =>
  import('@/assets/animations/confetti-background.json').then(
    (module) => module.default
  );

/** One confetti burst over the screen, gone once it has played. */
export function ConfettiBurst({ className }: ConfettiBurstProps) {
  const [isDone, setIsDone] = useState(false);

  if (isDone) return null;

  return (
    <LottieAnimation
      load={loadConfetti}
      className={className}
      onComplete={() => setIsDone(true)}
    />
  );
}
